"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionAscending = exports.arrayMean = void 0;
exports.arrayMean = function (array) {
    if (array.length === 0)
        return 0;
    var sum = array.reduce(function (acc, val) { return acc + val; }, 0);
    return sum / array.length;
};
exports.positionAscending = function (A, B) {
    if (B.position === null || B.position === undefined)
        return -1;
    if (A.position === null || A.position === undefined)
        return 1;
    return A.position - B.position;
};
exports.default = { arrayMean: exports.arrayMean, positionAscending: exports.positionAscending };
